import './App.css';
import GlobeComponent from './Globe';

function App() {
  return (
    <div className="App">
      <GlobeComponent/>
    </div>
  );
}

export default App;
